import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "info-group" }
const _hoisted_4 = { class: "qr-code" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_8 = { class: "button-group" }
const _hoisted_9 = {
  class: "demo-rich-conent",
  style: {"display":"flex","gap":"16px","flex-direction":"column"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_vue_qr = _resolveComponent("vue-qr")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("label", { for: "visibility" }, "显示设定", -1)),
        _createVNode(_component_el_select, {
          placeholder: "请选择",
          id: "visibility",
          modelValue: _ctx.option,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.option) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "非公开",
              value: "非公开"
            }),
            _createVNode(_component_el_option, {
              label: "公开",
              value: "公开"
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            (_ctx.form.id != null)
              ? (_openBlock(), _createBlock(_component_el_col, {
                  key: 0,
                  span: 12
                }, {
                  default: _withCtx(() => [
                    _cache[2] || (_cache[2] = _createElementVNode("p", null, [
                      _createElementVNode("strong", null, "正式版")
                    ], -1)),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_vue_qr, {
                        text: _ctx.qr_text,
                        size: 200
                      }, null, 8, ["text"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_col, {
              span: 12,
              class: "info-details"
            }, {
              default: _withCtx(() => [
                _cache[7] || (_cache[7] = _createElementVNode("p", null, [
                  _createElementVNode("strong", null, "地理位置:"),
                  _createTextVNode(" 任何地点 / 不限地区")
                ], -1)),
                (_ctx.form.createTime != null)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                      _cache[3] || (_cache[3] = _createElementVNode("strong", null, "建立时间:", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.form.createTime), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("p", null, [
                  (_ctx.form.releaseTime != null)
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_6, "发布时间:"))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.form.releaseTime), 1)
                ]),
                _createElementVNode("p", null, [
                  _cache[4] || (_cache[4] = _createElementVNode("strong", null, "游玩状态:", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.form.status == 0
                ? "审核中"
                : _ctx.form.status == 1
                ? "已发布"
                : _ctx.form.status == null
                ? "待发布"
                : "审核失败"), 1)
                ]),
                _createElementVNode("p", null, [
                  _cache[5] || (_cache[5] = _createElementVNode("strong", null, "版本号码:", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.form.version == null ? 0 : _ctx.form.version), 1)
                ]),
                (_ctx.form.remark != null)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                      _cache[6] || (_cache[6] = _createElementVNode("strong", null, "备注:", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.form.remark), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.releaseGame
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [
            _createTextVNode("发布新版本")
          ])),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_popover, {
          width: 150,
          "popper-style": "box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 20px;"
        }, {
          reference: _withCtx(() => _cache[9] || (_cache[9] = [
            _createElementVNode("div", { class: "tiyan" }, [
              _createElementVNode("span", null, "体验版"),
              _createElementVNode("span", null, [
                _createElementVNode("img", {
                  style: {"width":"15px","height":"15px"},
                  src: "https://img.51miz.com/Element/00/77/26/50/0ba4cf6c_E772650_6401310b.png",
                  alt: ""
                })
              ])
            ], -1)
          ])),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_vue_qr, {
                text: _ctx.qr_text2,
                size: 600
              }, null, 8, ["text"])
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}